// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"9ced0831","488":"3123a933","751":"70447fe5"}[chunkId] + ".chunk.js";
};